import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import api from '../api';

const CategoryCart = () => {
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const res = await api.get("/user/getOffers");
        setCategory(res.data.offers);
        // console.log("offres api call here", res.data.offers);
      } catch (err) {
        console.log("Failed to fetch section", err);
      }
    };

    fetchSections();
  }, []);

  // Moves exactly one card per click - no auto/continuous animation anymore.
  // Wraps around at the ends (next on last card jumps to first, and reverse).
  const goToSlide = (direction) => {
    const track = trackRef.current;
    if (!track) return;

    const firstCard = track.querySelector(".card-slide");
    const gap = 20; // must match the flex gap below
    const step = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth;
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (direction === "next") {
      if (track.scrollLeft >= maxScroll - 5) {
        track.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        track.scrollBy({ left: step, behavior: "smooth" });
      }
    } else {
      if (track.scrollLeft <= 5) {
        track.scrollTo({ left: maxScroll, behavior: "smooth" });
      } else {
        track.scrollBy({ left: -step, behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <section id="offers-section" className="banner__section section--padding">
        <div className="container-fluid offers-hero">
          {/* ✅ Background Logo */}
          <div className="offers-logo offers-logo-1"></div>
          <div className="offers-logo offers-logo-2"></div>
          <div className="offers-logo offers-logo-3"></div>

          {/* Heading */}
          <div className="banner-wrapper offers-wrapper">
            <div className="banner-container offers-badge">
              <span className="--maintitle banner-text offers-badge-text">
                OFFERS
              </span>
            </div>
          </div>

          {/* Category Grid */}
          <div className="row mb--n">
            <div className="container" style={{ position: "relative", zIndex: 1 }}>
              <div className="offers-viewport">
                {category.length > 1 && (
                  <button
                    type="button"
                    className="offers-nav offers-nav-prev"
                    onClick={() => goToSlide("prev")}
                    aria-label="Previous offer"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M15 18L9 12L15 6"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </button>
                )}

                <div className="offers-track" ref={trackRef}>
                  {category.map((cat, index) => (
                    <div
                      key={cat.id || cat._id || cat.slug || `cat-${index}`}
                      className="card-slide"
                    >
                      <div className="banner__items position-relative overflow-hidden card-hover">
                        <img
                          src={cat.poster}
                          alt={cat.description}
                          className="offers-img"
                        />

                        {/* Overlay & Button */}
                        <div className="banner__items--content">
                          <h4 className="offers-title">{cat.title}</h4>
                          {cat.description && (
                            <p className="offers-desc">{cat.description}</p>
                          )}
                          <button
                            className="offers-btn"
                            onClick={() =>
                              navigate(`/offers-listing/${cat._id}`, {
                                state: { title: cat.title, slug: cat.slug, poster: cat.poster },
                              })
                            }
                          >
                            Get Now <span style={{ fontSize: "14px", fontWeight: "bold" }}>→</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {category.length > 1 && (
                  <button
                    type="button"
                    className="offers-nav offers-nav-next"
                    onClick={() => goToSlide("next")}
                    aria-label="Next offer"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18L15 12L9 6"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Custom CSS - all in this file */}
        <style>
          {`
            #offers-section {
             
              padding-top: 60px;
              position: relative;
              overflow: hidden;
            }

            .offers-hero {
              position: relative;
              padding: 10px;
              background: linear-gradient(to bottom, rgba(255, 223, 100, 0.6) 0%, rgba(255, 223, 100, 0) 100%);
              backdrop-filter: blur(10px);
              -webkit-backdrop-filter: blur(10px);
              color: #000;
              overflow: visible;
            }

            /* Background logos */
            .offers-logo {
              position: absolute;
              background-image: url('/assets/img/overay.png');
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              opacity: 1;
              pointer-events: none;
              z-index: 0;
            }
            .offers-logo-1 {
              top: 18%;
              left: 90%;
              transform: translate(-50%, -50%) rotate(30deg);
              width: 180px;
              height: 180px;
              filter: blur(4px);
            }
            .offers-logo-2 {
              top: 20%;
              left: 10%;
              transform: translate(-50%, -50%) rotate(-20deg);
              width: 120px;
              height: 120px;
              filter: blur(5px);
            }
            .offers-logo-3 {
              top: 20%;
              left: 40%;
              transform: translate(-50%, -50%) rotate(45deg);
              width: 180px;
              height: 180px;
              filter: blur(5px);
            }

            /* Heading */
            .offers-wrapper {
              text-align: center;
              padding: 20px;
              position: relative;
              z-index: 1;
            }

            .offers-badge {
              display: inline-block;
              background: #fff;
              top: 5px;
              padding: 10px 30px;
              border: 2.7px solid #e0b200;
              border-top-right-radius: 25px;
              border-bottom-left-radius: 25px;
              border-top-left-radius: 0;
              border-bottom-right-radius: 0;
              position: relative;
              box-shadow: 0 0 15px rgba(255, 223, 100, 0.6);
              text-align: center;
            }

            .offers-badge-text {
              font-weight: bold;
              color: #000;
              font-size: 18px;
              letter-spacing: 1px;
            }

            /* Slider viewport - holds track + nav buttons */
            .offers-viewport {
              position: relative;
              overflow: hidden;
              width: 100%;
              padding: 10px 0;
            }

            /* Track - manual scroll now, no auto/continuous animation */
            .offers-track {
              display: flex;
              gap: 20px;
              overflow-x: auto;
              scroll-behavior: smooth;
              scroll-snap-type: x mandatory;
              -webkit-overflow-scrolling: touch;
              scrollbar-width: none; /* firefox */
              justify-content: flex-start;
              padding: 0 4px;
            }
            .offers-track::-webkit-scrollbar {
              display: none; /* chrome / safari */
            }

            /* Card wrapper - fixed width, one card = one scroll-snap stop */
            .card-slide {
              position: relative;
              z-index: 1;
              flex: 0 0 400px;
              width: 400px;
              min-width: 400px;
              scroll-snap-align: start;
            }

            /* Prev / Next buttons */
            .offers-nav {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              z-index: 3;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              border: none;
              background: #CEB256;
              color: #fff;
              font-size: 20px;
              line-height: 1;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
              transition: background 0.2s ease;
            }
            .offers-nav:hover {
              background: #b89a3f;
            }
            .offers-nav-prev { left: 8px; }
            .offers-nav-next { right: 8px; }

            /* Card visual box */
            .banner__items.card-hover {
              cursor: pointer;
              border-radius: 3px;
              box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
              transition: transform 0.3s ease, box-shadow 0.3s ease;
              height: 250px;
              z-index: 1;
               margin-top: 20px;
               margin-bottom: 10px;
            }
            .banner__items.card-hover:hover {
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
            }
            .banner__items.card-hover:hover .offers-img {
              transform: scale(2.08);
            }

            .offers-img {
              object-fit: contain;
              border-radius: 12px;
              transition: transform 0.5s ease;
              z-index: 1;
            }

            /* Overlay content on each card */
            

            .banner__items--content {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              padding: 15px;
              
              background: linear-gradient(to top, rgba(208, 183, 183, 0.8), rgba(0, 0, 0, 0.2));
              border: 2px solid #CEB256;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              text-align: left;
              z-index: 2;
            }

            .offers-title {
              color: #ffffff;
              font-weight: 700;
              font-size: 18px;
              margin-bottom: 8px;
            }

            .offers-desc {
              font-size: 14px;
              line-height: 1.5;
              max-width: 95%;
              color: #ffffff;
              margin-bottom: -30px;
            }

            .offers-btn {
              border-radius: 6px;
              padding: 10px 16px;
              font-size: 14px;
              background-color: #CEB256;
              color: white;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
              font-weight: 700;
              cursor: pointer;
              transition: transform 0.3s ease, box-shadow 0.3s ease;
              position: absolute;
              bottom: 15px;
              left: 15px;
              z-index: 2;
            }
            .offers-btn:hover {
              transform: translateY(-3px);
            }

            @media (max-width: 768px) {
              /* One card fills the viewport at a time on mobile */
              .card-slide {
                width: 100% !important;
                min-width: 100% !important;
                flex: 0 0 100% !important;
              }
              .offers-nav {
                width: 30px;
                height: 30px;
                font-size: 18px;
                top: 35%;
              }
            }
          `}
        </style>
      </section>
    </>
  )
}

export default CategoryCart